export enum AuthParamsValues {
  SIGNIN = 'signin',
  REGISTRATION = 'registration',
  FORGOT_PASSWORD = 'forgot_password',
}

export const AUTH_TYPE_KEY = 'auth';
export const USER_TYPE_KEY = 'type';
